/* eslint-disable */
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import React, { useEffect, useRef, useState, useContext } from 'react';
import { Card, Col, FormControl, FormLabel, Offcanvas, Row, Spinner } from 'react-bootstrap';
// import { tickets } from 'data/dashboard/support-desk';
//import { columns } from 'components/dashboards/support-desk/unsolved-tickets/TicketsLayout';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AllTicketsHeader from './AllTicketsHeader';
import TicketFilteringForm from './TicketFilteringForm';
import { useBreakpoints } from 'hooks/useBreakpoints';

import { getDrpContactTypes } from 'functions/dropdowns';
import { getPriorities, getTicketStatus, searchTickets } from 'functions/ticket';
import ItemsLoading1 from 'components/itemsLoading/ItemsLoading1';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import { Link, useLocation, useParams } from 'react-router-dom';
import SoftBadge from 'components/common/SoftBadge';
import classNames from 'classnames';
import moment from 'moment';
import avatarImg from 'assets/img/team/avatar.png';
import UnreadMessageBadge from 'components/badges/UnreadMessageBadge';
import PaginationBar from 'components/common/advance-table/PaginationBar';
import { timeElapsed } from 'components/shared/shared';
import { useSelector } from 'react-redux';
import { socket } from 'web_socket/socket';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import AppContext from 'context/Context';
const API = process.env.REACT_APP_API_PATH;


const PrioritySelect = ({ title, color, data, className, style }) => {
  return (
    <div
      style={style}
      className={classNames('d-flex align-items-center gap-2', className)}
    >
      <div style={{ '--falcon-circle-progress-bar': data }}>
        <svg
          className="circle-progress-svg"
          width="26"
          height="26"
          viewBox="0 0 120 120"
        >
          <circle
            className="progress-bar-rail"
            cx="60"
            cy="60"
            r="54"
            fill="none"
            strokeLinecap="round"
            strokeWidth="12"
          ></circle>
          <circle
            className="progress-bar-top"
            cx="60"
            cy="60"
            r="54"
            fill="none"
            strokeLinecap="round"
            stroke={color}
            strokeWidth="12"
          ></circle>
        </svg>
      </div>
      <h6 className="mb-0 text-700 fw-normal">{title}</h6>
    </div>
  );
};



const dayElapsed = (inputDate) => {
  const currentDate = new Date();
  const targetDate = new Date(inputDate);

  if (targetDate.toDateString() === currentDate.toDateString()) {
    return 'Today';
  } else {
    const yesterday = new Date(currentDate);
    yesterday.setDate(currentDate.getDate() - 1);

    if (targetDate.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    }
  }
}




const DueDate = ({ dueDate }) => {
  const formattedDueDate = moment.utc(dueDate).local();
  const currentDate = moment(); // Current local date

  let color = ''; // Initialize the color variable

  if (formattedDueDate.isSame(currentDate, 'day')) {
    color = 'red'; // Today
  } else if (formattedDueDate.isSame(currentDate.clone().add(1, 'day'), 'day')) {
    color = 'orange'; // Tomorrow
  }

  return (
    <div>
      {/* Render the Due on date with conditional color */}
      {dueDate && (
        <p style={{ marginLeft: '5px', color,fontWeight:'bold' }}>
          {`Due on: ${formattedDueDate.format('YYYY, DD MMM h:mm A')}`}
        </p>
      )}
    </div>
  );
};

const initialColumns = [

  {
    accessor: 'name',
    Header: 'Initiator',
    headerProps: { className: 'ps-2', style: { height: '46px' } },
    cellProps: {
      className: 'py-2 white-space-nowrap pe-3 pe-xxl-4 ps-2'
    },
    Cell: rowData => {
      const { name, avatar,id } = rowData.row.original;
      return (
        <Flex alignItems="center" className="position-relative py-1">
          {avatar.image ? (
            <Avatar src={avatar.image} size="xl" style={{ width: '40px', height: '40px' }} className="me-2" />
          ) : (
            <Avatar size="xl" style={{ width: '40px', height: '40px' }} name={avatar.name} className="me-2" />
          )}
          <h6 className="mb-0">
            <Link
              to={`/support-desk/tickets-preview/${id}`}
              className="stretched-link text-900 fw-normal"
            >
              {name}
            </Link>
          </h6>
        </Flex>
      );
    }
  },
  {
    accessor: 'ticketNumber',
    Header: 'Ticket#',
    headerProps: { style: { minWidth: '7rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { ticketNumber,id } = rowData.row.original;
      return (
        <Link to={`/support-desk/tickets-preview/${id}`} className="fw-semi-bold">
          {ticketNumber}
        </Link>
      );
    }
  },
  {
    accessor: 'subject',
    Header: 'Subject',
    headerProps: { style: { minWidth: '9.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { subject,unseenCount, id,dueDate } = rowData.row.original;
  
      return (
<>
        <div style={{ display: 'flex', alignItems: 'left' }}>
        {unseenCount !== 0 && <UnreadMessageBadge unreadCount={unseenCount} />}
        <Link
          to={`/support-desk/tickets-preview/${id}`}
          className="fw-normal"
          style={{
            display: 'inline-block',
            maxWidth: '160px', // Adjust the value as needed
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginLeft: '5px'
          }}
          title={subject} // Tooltip text
        >
          {subject}
        </Link>
      </div>
 
      </>
   
      );
    }
  },
  {
    accessor: 'status',
    Header: 'Status',
    headerProps: { style: { minWidth: '1rem' } },
    cellProps: {
      className: 'fs-0 pe-4'
    },
    Cell: rowData => {
      const { status } = rowData.row.original;
      return (
        <SoftBadge bg={status.type} className="me-2" style={{ maxWidth:'10px' }}>
        <span style={{ fontWeight: 'normal' }}>{status.content}</span>
      </SoftBadge>
      );
    }
  },
  {
    accessor: 'priority',
    Header: 'Priority',
    cellProps: {
      className: 'pe-4'
    },
    Cell: rowData => {
      const { priority,dueDate } = rowData.row.original;
      return (
        <> 
           <PrioritySelect
           
        title={priority.title}
        color={priority.color}
        data={priority.data}
        style={{marginTop:'5px'}}
      />
            {dueDate && <DueDate dueDate={dueDate}/>}
        </>
    
      );
    }
  },
  {
    accessor: 'agent',
    Header: 'Assignee',
    headerProps: { style: {  } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { agent } = rowData.row.original;
      return (
        <>
          {agent === 'Not Assigned' ? (
         <FormLabel className="fw-normal" style={{ color: 'red',fontSize:'12px' }}>
         {agent}
       </FormLabel>
          ) : (
            <Link className="fw-normal ">{agent}</Link>
          )}
        </>
      );
    }
  },

  {
    accessor: 'createdDate',
    Header: 'Created',
    headerProps: { style: { className: 'text-end' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { createdDate } = rowData.row.original;
  
      const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000; // One day in milliseconds
     
      const currentTime = new Date().getTime(); // Current timestamp in milliseconds
      const createdTime = new Date(createdDate);
    
      if (createdTime > currentTime - twentyFourHoursInMilliseconds) {
        const days_elapsed = dayElapsed(createdDate);
        const formattedTime = createdTime.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit'
        });
  
        return (

          <div style={{ minWidth: '110px', maxWidth: '110px', whiteSpace: 'normal', display: 'flex', flexDirection: 'column' }}>
          <p className="fw-normal" style={{ marginBottom: '4px' }}>{days_elapsed}</p>
          <p className="fw-normal">{formattedTime}</p>
        </div>

        );
      } else {
        const dateObj = new Date(createdDate);
  
        const formattedDate = dateObj.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
        const formattedTime = dateObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  
        return (
          <div style={{ minWidth: '110px', maxWidth: '110px', whiteSpace: 'normal', display: 'flex', flexDirection: 'column' }}>
            <p className="fw-normal" style={{ marginBottom: '4px' }}>{formattedDate}</p>
            <p className="fw-normal">{formattedTime}</p>
          </div>
        );
      }
    }
  }
  
  // time_elapsed

];

const TableView = () => {

  const [columns, setColumns] = useState([...initialColumns]); 
 
  const location=useLocation();
  const {ts_id,isRecent} =  useParams();

  useEffect(() => {
    const isRecentlyUpdatedTickets=isRecent==="1" ?true:false;
    setTableColumns(isRecentlyUpdatedTickets);
    },[isRecent]);

    const setTableColumns=(isRecentlyUpdatedTickets)=>{
      let updatedColumns = [...initialColumns];

      if (isRecentlyUpdatedTickets) {

        const recentActivityUpdatedDate_col = {
          accessor: 'recentActivityUpdatedDate',
          Header: 'Updated Date',
          headerProps: { style: { className: 'text-start' } },
          cellProps: {
            className: 'py-2 pe-4'
          },
          Cell: rowData => {
            const { recentActivityUpdatedDate, recentActivityUpdatedDescription,recentActivityUpdatedDescription_Color } = rowData.row.original;
            const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000; // One day in milliseconds
            const currentTime = new Date().getTime(); // Current timestamp in milliseconds
            const createdTime = new Date(recentActivityUpdatedDate);
        
            if (createdTime > currentTime - twentyFourHoursInMilliseconds) {
              const days_elapsed = dayElapsed(recentActivityUpdatedDate);
              const formattedTime = createdTime.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit'
              });
        
              return (
                <div style={{ minWidth: '110px', maxWidth: '110px', whiteSpace: 'normal', display: 'flex', flexDirection: 'column' }}>
                  <p className="fw-normal mb-1" style={{ fontStyle: 'italic', color: recentActivityUpdatedDescription_Color }}>{recentActivityUpdatedDescription}</p>
                  <p className="fw-normal mb-1">{days_elapsed}</p>
                  <p className="fw-normal">{formattedTime}</p>
                </div>
              );
            } else {
              const dateObj = new Date(recentActivityUpdatedDate);
              const today = new Date();
        
              const formattedDate = dateObj.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
              const formattedTime = dateObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
        
              return (
                <div style={{ minWidth: '110px', maxWidth: '110px', whiteSpace: 'normal', display: 'flex', flexDirection: 'column' }}>
                  <p className="fw-normal" style={{ marginBottom: '4px' }}>{recentActivityUpdatedDescription}</p>
                  {dateObj.toDateString() === today.toDateString() ? (
                    <p className="fw-normal" style={{ fontStyle: 'italic', color: 'gray' }}>Today</p>
                  ) : (
                    <p className="fw-normal">{formattedDate}</p>
                  )}
                  <p className="fw-normal">{formattedTime}</p>
                </div>
              );
            }
          }
        };
        
        
        

        updatedColumns = [recentActivityUpdatedDate_col, ...updatedColumns];
        setColumns(updatedColumns);
      }
      else {
        setColumns([...initialColumns]);
      }


   
    }

  const [show, setShow] = useState(false);
  const { breakpoints } = useBreakpoints();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [userData,setUserData]=useState(null);

  useEffect(()=>{

    const _userData=JSON.parse(localStorage.getItem('userData'));
    setUserData(_userData);
  console.log('userData',_userData);
  
  },[])

   const [tickets,setTickets]=useState([]);

  const [totalRowCount, setTotalRowCount] = useState(0);


  const pageIndex_saved=localStorage.getItem('pageIndex_ticketList') || 0;
   const [pageIndex, setPageIndex] = useState(parseInt(pageIndex_saved));

   const [limit,setLimit]=useState(10);
   const [isTicketLoading, setIsTicketLoading] = useState(false);


   const [searchPriority,setSearchPriority] = useState('0');
   const [searchCategory, setSearchCategory] = useState('0');
   const [searchContactType, setSearchContactType] = useState('0');
   const [searchAsset, setSearchAsset] = useState('0');
   const [searchTicketStatus, setSearchTicketStatus] = useState(5);
   const [searchAgent, setSearchAgent] = useState('0');
   const [searchCauseOfIssue, setSearchCauseOfIssue] = useState(null);
   const [searchCustomer, setSearchCustomer] = useState('0');
   const [searchChargingType, setSearchChargingType] = useState(null);
   const [searchCompany, setSearchCompany] = useState('0');

   const [ticketSearchFromDate, setTicketSearchFromDate] = useState('0');
   const [ticketSearchToDate, setTicketSearchToDate] = useState('0');
   


   useEffect(()=>{
    localStorage.setItem('pageIndex_ticketList',pageIndex)
   },[pageIndex]);

   const handlePageChange = newPageIndex => {
     setPageIndex(newPageIndex);

   };

     const setSelectedPriorityHandler = (value) => {
       console.log('--setSelectedPriorityPHandler', value);
     setSearchPriority(value);
     }
     
     const setSelectedCategoryHandler = (value) => {
       console.log('setSelectedCategoryHandler', value);
       setSearchCategory(value);
     }
     
     const setSelectedContactTypePHandler = (value) => {
       console.log('setSelectedContactTypePHandler', value);
       setSearchContactType(value);
     }
     
     const setSelectedAssetHandler = (value) => {
       console.log('setSelectedAssetHandler', value);
       setSearchAsset(value);
     }
     
     const setSelectedTicketStatusHandler = (value) => {
       console.log('setSelectedTicketStatusHandler', value);
       setSearchTicketStatus(value);
     }
     
     const setSelectedAgentHandler = (value) => {
       console.log('setSelectedAgentHandler', value);
       setSearchAgent(value);
     }
     
     const setSelectedCauseOfIssueHandler = (value) => {
      // console.log('setSelectedCauseOfIssueHandler', value);
       //setSearchCauseOfIssue(value);
     }
     
     const setSelectedCustomerHandler = (value) => {
       console.log('setSelectedCustomerHandler', value);
       setSearchCustomer(value);
     }
          
     const setSelectedChargingTypeHandler = (value) => {
      console.log('setSelectedChargingTypeHandler', value);
      //setSearchChargingType(value);
    }

    const setSelectedFromDateHandler=(value)=>{
      console.log('setSelectedFromDateHandler', value);
    }
    
    const setSelectedToDateHandler=(value)=>{
      console.log('setSelectedToDateHandler', value);
    }

    
    const setSelectedCompanyHandler = (value) => {
      console.log('setSelectedCompanyHandler', value);
      setSearchCompany(value);
    }

    const setTicketDateRangeHandler=(ticketDate)=>{
      console.log('ticketdate',ticketDate);
      if(ticketDate.fromDate && ticketDate.toDate){
        setTicketSearchFromDate(ticketDate.fromDate);
        setTicketSearchToDate(ticketDate.toDate);  
    }

    if(!ticketDate.fromDate && !ticketDate.toDate){
      setTicketSearchFromDate(ticketDate.fromDate);
      setTicketSearchToDate(ticketDate.toDate);  
  }}
  

  const clearPageIndexFunc=()=>{
    localStorage.removeItem('pageIndex_ticketList');
    setPageIndex(0);
  }

  const searchHandler=()=>{
    onSearch();
    clearPageIndexFunc();
  }


const currentPathName=localStorage.getItem('currentPathName');

  const [currentPath,setCurrentPath]=useState(currentPathName);
  const [loadingPath,setLoadingPath]=useState(location.pathname);
  
  useEffect(() => {
  
    if(currentPathName!=location.pathname){
      clearPageIndexFunc();
      //window.scrollTo(0, 0); // Default to top if no saved position
     // console.log('location different pathname detected',location.pathname,localStorage.getItem('currentPathName'));
    }
    
    localStorage.setItem('currentPathName',location.pathname);

   // clearPageIndexFunc();
  }, [location.pathname]);


const setScrolledPosition=()=>{
  const savedPosition = localStorage.getItem(`scrollPosition_`);
  if (savedPosition !== null) {
    window.scrollTo(0, parseInt(savedPosition, 10));
  } 
}


  // Save the scroll position to localStorage whenever the user scrolls
  // useEffect(() => {
  //   const handleScroll = () => {
  //     console.log('scrollPosition', window.scrollY);
  //     localStorage.setItem(`scrollPosition`, window.scrollY);
  //   };

  //   window.addEventListener('scroll', handleScroll);

  //   // Cleanup event listener on unmount
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, [location.pathname]);


  useEffect(() => {

    joinRoom('notification');
  }, []);

   const joinRoom=(room)=>{
    if(room!==""){
      socket.emit('join_room',room)
    }
  
  }


  // useEffect(() => {
  //   socket.on("receive_action", data => {
  //     console.log('receive_action triggerd table view');
  //    // if(data.action==="replyConversation"){

  //    const _skip = pageIndex * limit;
  //    loadDependancies(_skip,limit);
  //   //  }
  
  //   });
  // }, []);



  
  const [loadFiltered,setLoaFilterd]=useState(false);
   
  // useEffect(()=>{
  //   onSearch();
  // },[ts_id]);
  
  const onSearch=()=> {
 
    const _skip = pageIndex * limit;
    loadDependancies(_skip,limit);
  
  };


  useEffect(() => {
 
    const _skip = pageIndex * limit;
    loadDependancies(_skip,limit);
  
   },[searchPriority,searchCategory, searchContactType, searchAsset, ts_id,
    searchAgent, searchCauseOfIssue, searchCustomer,searchChargingType,searchCompany,pageIndex,
    ticketSearchFromDate,ticketSearchToDate,isRecent,ts_id]);



    // useEffect(() => {

    //   if(ts_id && ts_id!=0){
    //     console.log('ts_id',ts_id)
    //   setSearchTicketStatus(ts_id);
    //   }
    //   else{
    //     setSearchTicketStatus(null);
    //   }
    //  },[ts_id]);


   const loadDependancies=async (_skip,_limit)=>{
    
    if(searchPriority!=='0' || searchCategory!=='0' || searchContactType!=='0' || searchAsset!=='0' || searchAgent!=='0' || 
      searchCustomer!=='0' || searchCompany!=='0' || ticketSearchFromDate!=='0' || ticketSearchToDate!=='0' 
    ){

    setIsTicketLoading(true);
    const ticketStatus=  await loadTicketStatus();
     const priorities= await loadPriorities();
  
     const isRecentlyUpdatedTickets=isRecent==="1" ? true : false;

     console.log('_skip,limit--',
      _skip,_limit);

      console.log('--searchPriority:',searchPriority);
      console.log('--searchCategory:',searchCategory);
      console.log('--searchContactType:',searchContactType);
      console.log('--searchAsset:',searchAsset);
      console.log('--ts_id:',ts_id);
      console.log('searchAgent:',searchAgent);

      console.log('--searchCustomer:',searchCustomer);
      console.log('--searchCompany:',searchCompany);
      console.log('--ticketSearchFromDate:',ticketSearchFromDate);
      console.log('--ticketSearchToDate:',ticketSearchToDate);
      console.log('--isRecentlyUpdatedTickets:',isRecentlyUpdatedTickets);

 
    //  console.log('ff formattedFromDate:',formattedFromDate);
      console.log('----------------------');

   
    await loadTickets(priorities,ticketStatus,
      _skip,_limit,
      searchPriority, searchCategory, searchContactType, null, ts_id,
      searchAgent, searchCauseOfIssue, searchCustomer,searchChargingType,searchCompany,
       ticketSearchFromDate,ticketSearchToDate
     ,isRecentlyUpdatedTickets);
 

      setIsTicketLoading(false);

    }
   }

  const loadPriorities = async () => {
    try {
      const res = await getPriorities();
      const data = res.data;
      const priorities=[];
      data.map(p=>{
        priorities.push({priorityId:p.PriorityId,title:p.Priority,color:p.color,data:p.data});
      })
  return priorities;
    } catch (err) {
      console.log('Error', err);
    }
  };

  const loadTicketStatus = async () => {
    try {
      const res = await getTicketStatus();
      const data = res.data;
      const ticketStatusArr = [];
      data.map(p => {
        ticketStatusArr.push({
          ticketStatusId: p.TicketStatusId,
          content: p.StatusName,
          type: p.color
        });
      });

      return ticketStatusArr; // setTicketStatus(ticketStatusArr);
    } catch (err) {
      console.log('Error', err);
    }
  };
  


  const loadTickets = async (priorities,ticketStatus,skip=null,limit=null,
    searchPriority=null, searchCategory=null, searchContactType=null, searchAsset=null, searchTicketStatus=null,
     searchAgent=null, searchCauseOfIssue=null, searchCustomer=null,searchChargingType=null,searchCompany=null,
     ticketSearchFromDate,ticketSearchToDate,isRecentlyUpdatedTickets) => {
    try {
      const token=localStorage.getItem('token');
      searchPriority=searchPriority==='-1'?null:searchPriority;

     // searchPriority='-1'?null:searchPriority;
     searchCategory=searchCategory==='-1'?null:searchCategory;
     searchContactType=searchContactType==='-1'?null:searchContactType;
     searchAsset=searchAsset==='-1'?null:searchAsset;
     searchTicketStatus=searchTicketStatus==='-1'?null:searchTicketStatus;
     searchAgent=searchAgent==='-1'?null:searchAgent;
     searchCauseOfIssue=searchCauseOfIssue==='-1'?null:searchCauseOfIssue;
     searchCustomer=searchCustomer==='-1'?null:searchCustomer;
     searchChargingType=searchChargingType==='-1'?null:searchChargingType;
     searchCompany=searchCompany==='-1'?null:searchCompany;

      console.log('ss searchCompany',searchCompany)
      console.log('ss searchPriority',searchPriority)

      setIsTicketLoading(true);
      const searchData = {
      //  ticketMasterId,ticketNumber,
      priorityId:searchPriority,
      categoryId:searchCategory,
          contactTypeId:searchContactType,
          assetsMasterId:searchAsset,
          ticketStatusId: searchTicketStatus,
          assignedToUserId:searchAgent,
          causeOfIssueId:searchCauseOfIssue,
          customerId:searchCustomer,
          ticketChargingTypeId:searchChargingType,
          companyId:searchCompany,
          fromDate:ticketSearchFromDate,
          toDate:ticketSearchToDate,
          // subjectKW,
          // ticketNumberKW,
          // searchByKeyword,
          isRecentlyUpdatedTickets,
          skip,
          limit
      };
     const res = await searchTickets(searchData,token);

     const ticketsArr = [];
if(res){
  const { recordset, output } = res.data;
  console.log('record count',recordset);
  const totalRows = output.TotalRows;
  console.log('totalRows',totalRows);
  setTotalRowCount(totalRows)
  //  const noOfPages = Math.ceil(totalRows / limit);
  //  setNumberOfPages(noOfPages);
 

  recordset &&
    recordset.map(r => {
      let profileImg = `${API}/file/image/${r.ClientProfilePic}`;
      if (r.ClientProfilePic === null) {
        profileImg = avatarImg;
      }

      ticketsArr.push({
        id: r.TicketMasterId,
        ticketNumber: r.TicketNumber,
        name: r.Client,
        avatar: {
          name: r.Client,
          size: 'xl',
          round: 'circle',
          image: profileImg
        },
        subject: r.Subject,
        status: ticketStatus.filter(
          p => p.ticketStatusId === r.TicketStatusId
        )[0], //ticketsBadges[1],
        priority: priorities.filter(p => p.priorityId === r.PriorityId)[0], //getPriority(r.PriorityId),
        agent: r.Agent,
        createdDate: moment(r.CreatedDate_UTC).format('DD MMM, yyyy hh:mm A'),
        time_elapsed: timeElapsed(r.CreatedDate_UTC),
        lastDescription: r.lastDescription,
        unseenCount: r.UnseenCount,
        // company:r.CompanyName,
        dueDate: r.DueDate_UTC,
        recentActivityUpdatedDate:r.RecentActivityUpdatedDate,
        recentActivityUpdatedDescription:r.RecentActivityUpdatedDescription,
      recentActivityUpdatedDescription_Color:r.RecentActivityUpdatedDescription_Color
      });
    });
}
        setIsTicketLoading(false);

      setTickets(ticketsArr);
    } catch (err) {
      console.log('Error', err);
    }
  };

  // const loadTicketsSearchByKeywords = async (priorities,ticketStatus,
  //   searchPriority=null, searchCategory=null, searchContactType=null, searchAsset=null, searchTicketStatus=null,
  //    searchAgent=null, searchCauseOfIssue=null, searchCustomer=null) => {
  //   try {

  //     const searchData = {
  //     //  ticketMasterId,ticketNumber,
  //     priorityId:searchPriority,
  //     categoryId:searchCategory,
  //         contactTypeId:searchContactType,
  //         assetsMasterId:searchAsset,
  //         ticketStatusId: searchTicketStatus,
  //         agentId:searchAgent,
  //         causeOfIssueId:searchCauseOfIssue,
  //         customerId:searchCustomer,

  //         subjectKW,
  //         ticketNumberKW,
  //         searchByKeyword,
  //         skip,
  //         limit
  //     };
  //    const res = await searchTickets(searchData);
  //    const { recordset, output } = res.data;

  //     const ticketsArr = [];

  //     recordset &&
  //       recordset.map(r => {
  //         ticketsArr.push({
  //           id: r.TicketMasterId,
  //           ticketNumber:r.TicketNumber,
  //           name:r.Client,
  //           avatar: {
  //             name: r.Client,
  //             size: 'xl',
  //             round: 'circle'
  //           },
  //           subject: r.Subject,
  //           status:ticketStatus.filter(p => p.ticketStatusId === r.TicketStatusId)[0], //ticketsBadges[1],
  //           priority:priorities.filter(p => p.priorityId === r.PriorityId)[0], //getPriority(r.PriorityId),
  //           agent: r.Agent,
  //           date: r.time_elapsed
  //         });
  //       });
  //       console.log('ticketsArr',recordset)
  //     setTickets(ticketsArr);
  //   } catch (err) {
  //     console.log('Error', err);
  //   }
  // };
  // useEffect(() => {
  //  loadTickets();
  // }, []);

const onPageClickHandler=(obj)=>{
console.log('onPageClickHandler',obj)


}

const exportTicketsToExcel = async () => {
  // Prepare filter params from current state
  const token = localStorage.getItem('token');
  const stripHtml = (html) => {
    if (!html) return '';
    // Basic regex to remove tags, could be more advanced but good for Excel
    return html.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' ').trim();
  };

  const priorities = await loadPriorities();
  const ticketStatus = await loadTicketStatus();
  // Use current filter state, but skip=0 and a large limit to get all
  const searchData = {
    priorityId: searchPriority === '-1' ? null : searchPriority,
    categoryId: searchCategory === '-1' ? null : searchCategory,
    contactTypeId: searchContactType === '-1' ? null : searchContactType,
    assetsMasterId: null,
    ticketStatusId: ts_id === '-1' ? null : ts_id,
    assignedToUserId: searchAgent === '-1' ? null : searchAgent,
    causeOfIssueId: searchCauseOfIssue === '-1' ? null : searchCauseOfIssue,
    customerId: searchCustomer === '-1' ? null : searchCustomer,
    ticketChargingTypeId: searchChargingType === '-1' ? null : searchChargingType,
    companyId: searchCompany === '-1' ? null : searchCompany,
    fromDate: ticketSearchFromDate,
    toDate: ticketSearchToDate,
    isRecentlyUpdatedTickets: isRecent === '1' ? true : false,
    skip: 0,
    limit: 10000, // or whatever is safe for your backend
    includeDetails: true
  };
  try {
    const res = await searchTickets(searchData, token);
    const { recordset } = res.data;
    if (!Array.isArray(recordset) || recordset.length === 0) {
      alert('No tickets to export!');
      return;
    }
    const data = recordset.map(r => ({
      TicketNumber: r.TicketNumber,
      Client: r.Client,
      Subject: r.Subject,
      Status: (ticketStatus.filter(p => p.ticketStatusId === r.TicketStatusId)[0]?.content) || '',
      Priority: (priorities.filter(p => p.priorityId === r.PriorityId)[0]?.title) || '',
      Assignee: r.Agent,
      Date: r.CreatedDate_UTC ? moment(r.CreatedDate_UTC).format('DD MMM, yyyy hh:mm A') : '',
      Description: stripHtml(r.FullDescription).substring(0, 32000),
      Replies: stripHtml(r.Replies).substring(0, 32000),
      Messages: stripHtml(r.Messages).substring(0, 32000),
      ClosedBy: r.ClosedBy || ''
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet['!cols'] = [
      { wch: 16 }, // TicketNumber
      { wch: 22 }, // Client
      { wch: 32 }, // Subject
      { wch: 14 }, // Status
      { wch: 14 }, // Priority
      { wch: 18 }, // Assignee
      { wch: 18 }, // Date
      { wch: 50 }, // Description
      { wch: 50 }, // Replies
      { wch: 50 }, // Messages
      { wch: 18 }  // ClosedBy
    ];
    // Bold header row
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cell_address = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cell_address]) continue;
      worksheet[cell_address].s = { font: { bold: true } };
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Tickets');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', cellStyles: true });
    const file = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(file, 'tickets.xlsx');
  } catch (err) {
    alert('Failed to export tickets.');
    console.error(err);
  }
};

const pageCount = Math.ceil(totalRowCount / limit);


  const { config } = useContext(AppContext);
  const { isDark } = config;
  const textColor = isDark ? '#fff' : '#212529';
  const tableBg = isDark ? undefined : '#fff';

  // Inject style for table text color based on dark/light mode
  const tableTextColorStyle = (
    <style key="table-text-color-style">{`
      .table thead th, .table tbody td, .table tfoot td, .table th, .table td {
        color: ${isDark ? '#fff' : '#212529'} !important;
      }
      .table thead, .table tfoot {
        background: ${isDark ? '#23272b' : '#f8f9fa'} !important;
      }
      .table {
        background: ${tableBg || 'inherit'} !important;
      }
    `}</style>
  );

  const ListTickets = () => (
    <AdvanceTableWrapper
      columns={columns}
      data={tickets}
      sortable
      pagination
      perPage={11}
      rowCount={tickets.length}
    >
      <Card>
        <Card.Header className="border-bottom border-200 px-0" style={{ color: textColor, background: tableBg }}>
          <AllTicketsHeader
            totalRowCount={totalRowCount}
            table
            layout="table-view"
            handleShow={handleShow}
            exportTicketsToExcel={exportTicketsToExcel}
          />
        </Card.Header>
        <Card.Body className="p-0" style={{ background: tableBg }}>
          {isTicketLoading ? (
            <div className="p-5 d-flex align-items-center justify-content-center" style={{ color: textColor }}>
              <ItemsLoading1
                animation="border"
                size="sm"
                message="Loading please wait..."
              />
            </div>
          ) : (
            <>
              {tableTextColorStyle}
              <AdvanceTable
                table
                isRecentActivityUpdatedDate={true}
                headerClassName="bg-light text-800 align-middle"
                rowClassName="btn-reveal-trigger align-middle"
                tableProps={{
                  size: 'sm',
                  className: 'fs--1 mb-0 overflow-hidden',
                  style: { color: textColor, background: tableBg },
                }}
              />
            </>
          )}
        </Card.Body>
        <Card.Footer style={{ color: textColor, background: tableBg }}>
          <AdvanceTablePagination
            canPreviousPage={pageIndex > 0}
            canNextPage={pageIndex < pageCount - 1}
            previousPage={() => setPageIndex(old => Math.max(old - 1, 0))}
            nextPage={() => setPageIndex(old => Math.min(old + 1, pageCount - 1))}
            pageCount={pageCount}
            pageIndex={pageIndex}
            gotoPage={page => setPageIndex(page)}
          />
        </Card.Footer>
      </Card>
    </AdvanceTableWrapper>
  )

// const ListTicketsClient=()=>{
//   return (
//     <AdvanceTableWrapper
//       columns={columns}
//       data={tickets}
//       selection
//       selectionColumnWidth={52}
//       sortable
//       pagination
//       perPage={11}
//       rowCount={tickets.length}
//     >
//       <Card>
//         <Card.Header className="border-bottom border-200 px-0">
//           <AllTicketsHeader table layout="table-view" handleShow={handleShow} />
//         </Card.Header>
//         <Card.Body className="p-0">
//           {isTicketLoading ? (
//             <div className="p-5 d-flex align-items-center justify-content-center">
//               <ItemsLoading1
//                 animation="border"
//                 size="sm"
//                 message="Loading please wait..."
//               />
//             </div>
//           ) : (
//             <AdvanceTable
//               table
//               headerClassName="bg-light text-800 align-middle"
//               rowClassName="btn-reveal-trigger align-middle"
//               tableProps={{
//                 size: 'sm',
//                 className: 'fs--1 mb-0 overflow-hidden'
//               }}
//             />
//           )}
//         </Card.Body>
//         <Card.Footer>
//           <AdvanceTablePagination table />
//         </Card.Footer>
//       </Card>
//     </AdvanceTableWrapper>
//   );
// }

  return (
    <>
    <Row className="gx-3">
    {/* {JSON.stringify(priorities)} */}
    <Col xxl={10} xl={10}>

    {userData && userData.roleId === 1 && <ListTickets />} 
    {userData && userData.roleId === 5 && <ListTickets />} 
    {userData && userData.roleId === 4 && <ListTickets />} 
        {userData && userData.roleId === 3 && <ListTickets />} 
     {userData && userData.roleId === 2 && <ListTickets />}
    </Col>
    <Col xxl={2} xl={2}>
      {breakpoints.down('xl') ? (
        <Offcanvas
          show={show}
          onHide={handleClose}
          placement="end"
          className="dark__bg-card-dark"
        >
          <Offcanvas.Header closeButton className="bg-light">
            <h6 className="fs-0 mb-0 fw-semi-bold">Filter</h6>
          </Offcanvas.Header>
          <TicketFilteringForm
            setSelectedPriorityFunc={setSelectedPriorityHandler}
            setSelectedCategoryFunc={setSelectedCategoryHandler}
            setSelectedContactTypeFunc={setSelectedContactTypePHandler}
            setSelectedAssetFunc={setSelectedAssetHandler}
            setSelectedTicketStatusFunc={setSelectedTicketStatusHandler}
            setSelectedTicketAssignedUserFunc={setSelectedAgentHandler}
            setSelectedCauseOfIssueFunc={setSelectedCauseOfIssueHandler}
            setSelectedCustomerFunc={setSelectedCustomerHandler}
            setSelectedChargingTypeFunc={setSelectedChargingTypeHandler}
            setSelectedCompanyFunc = {setSelectedCompanyHandler}
            setTicketDateRangeFunc= {setTicketDateRangeHandler}
            clearPageIndexFunc={clearPageIndexFunc}
            tblViewCurrentPath={currentPath}
            tblViewNewPath={loadingPath}
            //searchHandler={searchHandler}
   
          />
        </Offcanvas>
      ) : (
        <TicketFilteringForm
          setSelectedPriorityFunc={setSelectedPriorityHandler}
          setSelectedCategoryFunc={setSelectedCategoryHandler}
          setSelectedContactTypeFunc={setSelectedContactTypePHandler}
          setSelectedAssetFunc={setSelectedAssetHandler}
          setSelectedTicketStatusFunc={setSelectedTicketStatusHandler}
          setSelectedTicketAssignedUserFunc={setSelectedAgentHandler}
          setSelectedCauseOfIssueFunc={setSelectedCauseOfIssueHandler}
          setSelectedCustomerFunc={setSelectedCustomerHandler}
          setSelectedChargingTypeFunc={setSelectedChargingTypeHandler}
          setSelectedCompanyFunc = {setSelectedCompanyHandler}
          setTicketDateRangeFunc= {setTicketDateRangeHandler}
          clearPageIndexFunc={clearPageIndexFunc}
          tblViewCurrentPath={currentPath}
          tblViewNewPath={loadingPath}
          //searchHandler={searchHandler}
        />
      )}
    </Col>
  </Row>


    </>
  );

  
};

// Export tickets to Excel (filtered)


export default TableView;
/* eslint-disable */